export default function transformCategoryToSlug(category: any) {
  return category.split(' ').join('-').toLowerCase()
}
